export const InsEventTypeEnums = {
  INS_ACCESS: 'ins_access',
  INS_CHECK: 'ins_check',
}
